import { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Clickable from 'components/Common/Clickable'
import Image from 'components/Common/Image'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import GeoContext from 'contexts/geoContext'
import { campaignRegionImages } from 'components/utils/tour-luxplus-campaign-regions'
import OfferUrgencyCountdownLabel from 'components/Common/Labels/OfferUrgencyCountdownLabel'
import { LUX_PLUS_TOURS_CAMPAIGN } from 'luxPlus/constants/base'
import useIsLuxPlusToursCampaignActive from 'luxPlus/hooks/useIsLuxPlusToursCampaignActive'

const BannerLink = styled(Clickable)`
  position: relative;
  display: block;
`

const BannerImage = styled(Image)`
  padding-top: ${rem(5)};
  padding-bottom: ${rem(20)};
  width: 100%;
`

const CountdownWrapper = styled.div`
  position: absolute;
  top: ${rem(16)};
  right: ${rem(16)};
  z-index: 1;
  pointer-events: none;
`

function TourLuxPlusDiscountBanner() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)
  const isLuxPlusToursCampaignActive = useIsLuxPlusToursCampaignActive()

  const images = campaignRegionImages[currentRegionCode as keyof typeof campaignRegionImages]

  if (!images || !isLuxPlusToursCampaignActive) {
    return null
  }

  const altText = intl.formatMessage(
    {
      id: 'I_9X_MAvuMZcNl04p6hY',
      defaultMessage: 'Unlock an extra 5% off tours with LuxPlus+',
      description: 'Alt text for LuxPlus+ discount banner image on tours page',
    },
  )

  return <BannerLink to="/search/tours?destinationId=le_d41d8cd98f00b204e9800998ecf8427e&destinationName=Anywhere&categories=luxexclusive">
    <CountdownWrapper>
      <OfferUrgencyCountdownLabel
        endDate={LUX_PLUS_TOURS_CAMPAIGN.END_DATE.toISOString()}
        tagPlace="common-labels"
      />
    </CountdownWrapper>
    <CSSBreakpoint min="tablet">
      <BannerImage image={{ id: images.desktop }} alt={altText} />
    </CSSBreakpoint>
    <CSSBreakpoint max="mobile">
      <BannerImage image={{ id: images.mobile }} alt={altText} />
    </CSSBreakpoint>
  </BannerLink>
}

export default TourLuxPlusDiscountBanner
